import { QueryResult } from 'react-query';
import { Controller, useApi, UseApiOptions } from './useApi';

export type RecordType = 'angebot' | 'auftrag' | 'bestellung' | 'lieferung' | 'rechnung';

export interface ArtikelDetailHistorie {
    recNum: number;
    artikelGruppeNr: number;
    artikelNr: string;
    kNr?: number;
    kName1?: string;
    kName2?: string;
    recordType?: RecordType;
    recordNr?: string;
    action: string;
    note?: string;
    oldLArt: string;
    oldMenge: number;
    oldBestand: number;
    oldOffenBest: number;
    oldOffenBestD: number;
    oldOffenLief: number;
    oldOffenLiefD: number;
    oldOffenRes: number;
    newLArt: string;
    newMenge: number;
    newBestand: number;
    newOffenBest: number;
    newOffenBestD: number;
    newOffenLief: number;
    newOffenLiefD: number;
    newOffenRes: number;

    anlageDat?: string;
    anlageUhr?: number;
    anlageUser?: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export interface ArtikelDetailHistorieFilter {
    artikelGruppeNr?: number;
    artikelNr?: string;
    maxRows?: number;
}

export function useArtikelDetailHistorieList(
    filter: ArtikelDetailHistorieFilter,
    apiOptions?: UseApiOptions<ArtikelDetailHistorie[]>,
): QueryResult<ArtikelDetailHistorie[]> {
    return useApi<ArtikelDetailHistorie[]>(Controller.artikelDetail + '/historielist', { filter }, apiOptions);
}
